import React from 'react'
import { LinkButton } from '../link-button'
import { NavItem } from 'reactstrap'
import PropTypes from 'prop-types'

export function LogoutNavItem (props) {
  return (
    <NavItem>
      <LinkButton to='/logout' url={props.url} className='nav-link'>
        <svg className='icon mr-md-0 mr-xl-1' role='img' width='20' height='20' aria-hidden='true'>
          <title>Log out</title>
          <use xlinkHref='#logout_rounded' href='#logout_rounded' />
        </svg>
        <div className='d-none d-xl-block'>Log out</div>
      </LinkButton>
    </NavItem>
  )
}

LogoutNavItem.propTypes = {
  url: PropTypes.object
}
